import { Actions } from './business-categories.actions'
import { fromJS } from 'immutable'
import * as businessCategoriesTypes from './business-categories.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
    results: 0,
  },
  createBusinessCategory: {
    isLoading: false,
    validationErrors: {},
    data: {
      name: '',
    },
  },
  updateBusinessCategory: {
    isLoading: false,
    shouldReload: false,
    validationErrors: {},
    data: {},
  },
  updateBusinessSubcategory: {
    isLoading: false,
    validationErrors: {},
    data: {
      name: '',
      logicSlots: [],
    },
  },
  subcategories: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
  },
  createBusinessSubcategory: {
    isLoading: false,
    validationErrors: {},
    data: {
      name: '',
      logicSlots: [],
    },
  },
})

export function businessCategoriesReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case businessCategoriesTypes.UPDATE_BUSINESS_CATEGORY_REQUEST: {
      return state.setIn(['updateBusinessCategory', 'isLoading'], true)
    }

    case businessCategoriesTypes.UPDATE_BUSINESS_CATEGORY_SUCCESS: {
      return state.setIn(['updateBusinessCategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.UPDATE_BUSINESS_CATEGORY_FAILURE: {
      return state.setIn(['updateBusinessCategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.CREATE_BUSINESS_CATEGORY_REQUEST: {
      return state.setIn(['createBusinessCategory', 'isLoading'], true)
    }

    case businessCategoriesTypes.CREATE_BUSINESS_CATEGORY_SUCCESS: {
      return state.setIn(['createBusinessCategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.CREATE_BUSINESS_CATEGORY_FAILURE: {
      return state.setIn(['createBusinessCategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.CREATE_BUSINESS_SUBCATEGORY_REQUEST: {
      return state.setIn(['createBusinessSubcategory', 'isLoading'], true)
    }

    case businessCategoriesTypes.CREATE_BUSINESS_SUBCATEGORY_SUCCESS: {
      return state.setIn(['createBusinessSubcategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.CREATE_BUSINESS_SUBCATEGORY_FAILURE: {
      return state.setIn(['createBusinessSubcategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.DELETE_BUSINESS_CATEGORY_REQUEST: {
      return state
    }

    case businessCategoriesTypes.DELETE_BUSINESS_CATEGORY_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case businessCategoriesTypes.DELETE_BUSINESS_CATEGORY_FAILURE: {
      return state
    }

    case businessCategoriesTypes.FETCH_BUSINESS_CATEGORIES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case businessCategoriesTypes.FETCH_BUSINESS_CATEGORIES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case businessCategoriesTypes.FETCH_BUSINESS_CATEGORIES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case businessCategoriesTypes.FETCH_BUSINESS_CATEGORY_REQUEST: {
      return (
        state
          // .setIn(['updateBusinessCategory', 'isLoading'], true)
          .setIn(['updateBusinessCategory', 'shouldReload'], false)
      )
    }

    case businessCategoriesTypes.FETCH_BUSINESS_CATEGORY_SUCCESS: {
      return state
        .setIn(['updateBusinessCategory', 'isLoading'], false)
        .setIn(['updateBusinessCategory', 'data'], fromJS(action.payload))
        .setIn(
          ['updateBusinessCategory', 'data', 'licenseTypeId'],
          action.payload.licenseType?.id,
        )
        .setIn(['subcategories', 'data'], fromJS(action.payload.subCategories))
    }

    case businessCategoriesTypes.FETCH_BUSINESS_CATEGORY_FAILURE: {
      return state.setIn(['updateBusinessCategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.FETCH_BUSINESS_SUBCATEGORY_REQUEST: {
      return state.setIn(['updateBusinessSubcategory', 'isLoading'], true)
    }

    case businessCategoriesTypes.FETCH_BUSINESS_SUBCATEGORY_SUCCESS: {
      return state
        .setIn(['updateBusinessSubcategory', 'isLoading'], false)
        .setIn(
          ['updateBusinessSubcategory', 'data'],
          fromJS({
            ...action.payload,
            subCategoryType: action.payload.subCategoryType.name,
            logicSlots: action.payload.logicSlots.map((slot) => ({
              ...slot,
              calculationType: slot.calculationType.name,
            })),
          }),
        )
    }

    case businessCategoriesTypes.FETCH_BUSINESS_SUBCATEGORY_FAILURE: {
      return state.setIn(['updateBusinessSubcategory', 'isLoading'], false)
    }

    case businessCategoriesTypes.DELETE_BUSINESS_SUBCATEGORY_SUCCESS: {
      return state.setIn(['updateBusinessCategory', 'shouldReload'], true)
    }

    case businessCategoriesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case businessCategoriesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
